const StarFull = ({ color }) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L14.9 8.6L22 9.3L17 14.1L18.3 21.2L12 17.8L5.7 21.2L7 14.1L2 9.3L9.1 8.6L12 2Z"/>
    </svg>
);

const StarHalf = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <defs>
      <linearGradient id="halfGradient" x1="0" x2="1" y1="0" y2="0">
        <stop offset="50%" stopColor={color} />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      d="M12 2L14.9 8.6L22 9.3L17 14.1L18.3 21.2L12 17.8L5.7 21.2L7 14.1L2 9.3L9.1 8.6L12 2Z"
      fill="url(#halfGradient)"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);


const StarEmpty = ({ color }) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L14.9 8.6L22 9.3L17 14.1L18.3 21.2L12 17.8L5.7 21.2L7 14.1L2 9.3L9.1 8.6L12 2Z"/>
    </svg>
);

const RatingStars = ({ average_rating, newColor = '#FFD700' }) => {
    const fullStars = Math.floor(average_rating);
    const hasHalfStar = average_rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const stars = [];

    for (let i = 0; i < fullStars; i++) {
        stars.push(<StarFull key={`full-${i}`} color={newColor} />);
    }

    if (hasHalfStar) {
        stars.push(<StarHalf key="half" color={newColor} />);
    }

    for (let i = 0; i < emptyStars; i++) {
        stars.push(<StarEmpty key={`empty-${i}`} color={newColor} />);
    }

    return <div className="upgrade_rating_stars" style={{ display: 'flex', gap: '2px' }}>{stars}</div>;
};

export default RatingStars;
